// store/balance/useBalanceStore.ts

import { create } from 'zustand';
import { persist, combine } from 'zustand/middleware';
import { exercicesInitialState, ExercicesState } from './exercicesInitialState';
import { createExercicesSlice, ExercicesActions } from './createExercicesSlice';
import { Exercice } from 'src/types';

export const useExercicesStore = create<ExercicesState & ExercicesActions>()(
  persist(combine(exercicesInitialState, createExercicesSlice as any), {
    name: 'exercices-store',

    onRehydrateStorage: () => (state) => {
      if (!state) return;

      const reviveRange = (
        range: [string | Date | null, string | Date | null] | null,
      ): [Date | null, Date | null] | null => {
        if (!range) return null;

        return [range[0] ? new Date(range[0]) : null, range[1] ? new Date(range[1]) : null];
      };

      const reviveExercices = (exercices: Exercice[] = []): Exercice[] =>
        exercices.map((exercice) => ({
          ...exercice,
          dateStart: exercice.dateStart ? new Date(exercice.dateStart) : exercice.dateStart,
          dateEnd: exercice.dateEnd ? new Date(exercice.dateEnd) : exercice.dateEnd,
          situations: exercice.situations?.map((situation) => ({
            ...situation,
            date: situation.date ? new Date(situation.date) : situation.date,
          })),
        }));

      state.selectedDateRange = reviveRange(state.selectedDateRange);
      state.selectedDateRangePeriod1 = reviveRange(state.selectedDateRangePeriod1);
      state.selectedDateRangePeriod2 = reviveRange(state.selectedDateRangePeriod2);
      state.activeExercices = reviveExercices(state.activeExercices);
      state.secondaryActiveExercices = reviveExercices(state.secondaryActiveExercices);
    },
  }),
);
